import cryptoJs from 'crypto-js';
import axios from 'axios';

// sign  считается так:
// берется обьект, с полями такими же, как JSON, описанный выше, но без поля sign.
// Каждая пара ключ-значение кодируется в строку: "<key>=<value>"
// затем список этих пар сортируется лексикографически, затем join'им все эти строки в одну
// в конце join'им к этому секрет: fw1p8945oefp52ip25hogsdrjn2  (этот секрет работает только для API с id-шниками, так что его тоже не страшно засветить)
// Берем от полученной в конце п.4 строки берем хеш sha256
// Полученный хеш кодируем в Base16 в lowercase
export function generateSignature(data: Record<string, any>) {
  const secret = 'fw1p8945oefp52ip25hogsdrjn2';
  let keyValuePairs = [];

  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      let value = data[key];
      if (Array.isArray(value)) {
        value = value.join(',');
      }
      keyValuePairs.push(`${key}=${value}`);
    }
  }

  keyValuePairs.sort(); // Лексикографическая сортировка
  const stringToHash = keyValuePairs.join('') + secret; // Объединяем строки и добавляем секрет

  // Использование CryptoJS для генерации SHA-256 хеша и преобразования его в Hex строку
  const hash = cryptoJs.SHA256(stringToHash);
  return hash.toString(cryptoJs.enc.Hex);
}

const URL_BASE = process.env.REACT_APP_REST_API_URL;
const GET_IDS_URL = `${URL_BASE}/my_games_store/api/get_ids`;

export async function postDataWithSignature(publicId: string) {
  const data = {
    input_id_type: 'public_id',
    output_id_type: 'player_id',
    ids: [`${publicId}`],
  };

  const signature = generateSignature(data);

  try {
    // Отправка данных с подписью с использованием Axios
    const response = await axios.post(GET_IDS_URL, {
      ...data,
      sign: signature,
    });

    console.log(response.data?.ids_map[publicId]);
    return response.data?.ids_map[publicId]; // Возвращаем данные ответа
  } catch (error) {
    console.error('Ошибка при отправке данных:', error);
    throw error; // Перебрасываем ошибку дальше
  }
}
